import { Typography } from "antd";
import PaymentStatus from "../../../../types/paymentStatus.type";

interface StatusFormProps {
  status: string;
  content: string;
  title?: string;
}

export const statusNames: Record<string, string> = {
  [PaymentStatus.DRAFT]: "Draft",
  [PaymentStatus.PENDING]: "Awaiting Review",
  [PaymentStatus.PROCESSING]: "Processing",
  [PaymentStatus.APPROVED]: "Approved",
  [PaymentStatus.REJECTED]: "Rejected",
  [PaymentStatus.COMPLETED]: "Completed",
  [PaymentStatus.POSTPONED]: "Postponed",
  [PaymentStatus.CONFIRMING]: "Processing",
  [PaymentStatus.CONFIRMED]: "Confirmed",
  [PaymentStatus.REVIEW]: "Awaiting Review",
  [PaymentStatus.FAILED]: "Failed",
  [PaymentStatus.CANCELLED]: "Cancelled",
  [PaymentStatus.SUCCESS]: "Success",
};

export const statusColors: Record<string, string> = {
  [PaymentStatus.DRAFT]: "rgba(145, 148, 150, 1)",
  [PaymentStatus.REVIEW]:
    "linear-gradient(180deg, rgba(248, 203, 14, 1) 0%,rgba(236, 86, 51, 1) 100%)",
  [PaymentStatus.PENDING]:
    "linear-gradient(180deg, rgba(248, 203, 14, 1) 0%,rgba(236, 86, 51, 1) 100%)",
  [PaymentStatus.PROCESSING]:
    "linear-gradient(180deg, rgba(248, 203, 14, 1) 0%,rgba(236, 86, 51, 1) 100%)",
  [PaymentStatus.POSTPONED]:
    "linear-gradient(180deg, rgba(248, 203, 14, 1) 0%,rgba(236, 86, 51, 1) 100%)",
  [PaymentStatus.APPROVED]: "rgb(29, 171, 241)",
  [PaymentStatus.REJECTED]: "rgb(236, 51, 51)",
  [PaymentStatus.COMPLETED]: "rgba(24, 184, 83, 1)",
  [PaymentStatus.CANCELLED]: "rgba(145, 148, 150, 1)",
  [PaymentStatus.FAILED]: "rgb(236, 51, 51)",
  [PaymentStatus.CONFIRMING]: "rgb(250, 173, 20)",
  [PaymentStatus.CONFIRMED]: "rgb(29, 171, 241)",
  [PaymentStatus.SUCCESS]: "rgb(24, 184, 83)",
};

const StatusForm = ({ title, status, content }: StatusFormProps) => {
  return (
    <div className="form-history-status-box">
      <div className="form-history-status-box-title">
        {title ? (
          <Typography className="form-history-status-box-id">
            {title}
          </Typography>
        ) : null}
        <div
          style={{
            borderRadius: "6px",
            width: "fit-content",
            padding: "3px 8px",
            background: statusColors[status],
          }}
        >
          {statusNames[status]}
        </div>
        {content ? (
          <Typography className="form-history-status-box-content">
            {content}
          </Typography>
        ) : null}
      </div>
    </div>
  );
};

export default StatusForm;
